import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownLeftAndUpRightToCenter, faUpRightAndDownLeftFromCenter } from '@fortawesome/free-solid-svg-icons';

//STYLES
import {
    BotaoRecolher, ConteudoAlteracoesMalha, ContainerAlteracoesMalha, HeaderAlteracoesMalha,
    LabelAlteracoesMalha
} from './styled';

//COMPONENTS
import { Switcher } from '../../../../../../../../../../../../../../../../Components/CustomUi/Switcher';
import { Tooltip } from 'antd';

interface PropsAlteracoesMalha {
    inserirPontos: boolean
    setInserirPontos: React.Dispatch<React.SetStateAction<boolean>>
    moverPontos: boolean
    setMoverPontos: React.Dispatch<React.SetStateAction<boolean>>
    /** `flutuante` = card sobre o mapa (padrão); `sidebar` = seção na tela cheia. */
    variante?: 'flutuante' | 'sidebar'
}

export const AlteracoesMalha: React.FC<PropsAlteracoesMalha> = ({ inserirPontos, setInserirPontos,
    moverPontos, setMoverPontos, variante = 'flutuante'
}) => {

    const [recolhido, setRecolhido] = useState<boolean>(false)

    const pode_recolher = variante === 'flutuante'

    /**
     * Sem o botão na tela cheia, um `recolhido` herdado da janela normal deixaria os
     * switchers escondidos sem como trazê-los de volta: ali o bloco é sempre expandido.
     */
    const esta_recolhido = pode_recolher && recolhido

    return (
        <ContainerAlteracoesMalha $variante={variante} $recolhido={esta_recolhido}>
            <HeaderAlteracoesMalha
                type='button'
                $recolhido={esta_recolhido}
            >
                {/* Recolhido o card fica só com o ícone, então o título sai do fluxo. */}
                {!esta_recolhido && <LabelAlteracoesMalha>Habilitar alterações</LabelAlteracoesMalha>}

                {pode_recolher && (
                    <Tooltip title={esta_recolhido ? 'Exibir controles de alterações' : 'Ocultar controles de alterações'}>
                        <BotaoRecolher onClick={() => setRecolhido(!recolhido)}>
                            <FontAwesomeIcon
                                icon={esta_recolhido ? faUpRightAndDownLeftFromCenter : faDownLeftAndUpRightToCenter}
                            />
                        </BotaoRecolher>
                    </Tooltip>
                )}
            </HeaderAlteracoesMalha>

            {/* Mantido montado e apenas oculto: desmontar reiniciaria a animação e o
                estado dos switchers a cada abertura. */}
            <ConteudoAlteracoesMalha $recolhido={esta_recolhido}>
                <Switcher
                    label='Inserir pontos'
                    isChecked={inserirPontos}
                    trigger={(checked) => {
                        setInserirPontos(checked)
                        if (checked) setMoverPontos(false)
                    }}
                />
                <Switcher
                    label='Mover pontos'
                    isChecked={moverPontos}
                    trigger={(checked) => {
                        setMoverPontos(checked)
                        if (checked) setInserirPontos(false)
                    }}
                />
            </ConteudoAlteracoesMalha>
        </ContainerAlteracoesMalha>
    )
}
